import "./index.css";
import {jsxs as $4MPRY$jsxs, jsx as $4MPRY$jsx} from "react/jsx-runtime";
import {forwardRef as $4MPRY$forwardRef, useState as $4MPRY$useState, useEffect as $4MPRY$useEffect, useImperativeHandle as $4MPRY$useImperativeHandle} from "react";




const $090815f5086f7f29$export$5acdf7f97c483469 = /*#__PURE__*/ (0, $4MPRY$forwardRef)((props, ref)=>{
    const [showOptions, setShowOptions] = (0, $4MPRY$useState)(false);
    const [search, setSearch] = (0, $4MPRY$useState)("");
    const [selectedOptions, setSelectedOptions] = (0, $4MPRY$useState)(props.defaultValues || []);
    const [currentIndex, setCurrentIndex] = (0, $4MPRY$useState)(-1);
    (0, $4MPRY$useEffect)(()=>{
        props.onChange && props.onChange(selectedOptions);
        selectedOptions.length >= props.selectionLimit && setShowOptions(false);
    }, [
        selectedOptions
    ]);
    (0, $4MPRY$useEffect)(()=>{
        !showOptions && setCurrentIndex(-1);
    }, [
        showOptions
    ]);
    (0, $4MPRY$useImperativeHandle)(ref, ()=>({
            setOptions: (options)=>setSelectedOptions(options)
        }));
    const getOption = (option, index = "value")=>{
        return props.optionsObject ? option[props.optionsObject[index]] : option;
    };
    const toggleOptions = ()=>setShowOptions(!showOptions);
    const handleSearch = (event)=>setSearch(event.target.value);
    const selectOption = (option)=>{
        setSelectedOptions([
            ...selectedOptions,
            getOption(option, "key")
        ]);
        setSearch("");
    };
    const removeOption = (value)=>{
        setSelectedOptions(selectedOptions.filter((option)=>option !== value));
    };
    const filter = (option)=>{
        const key = getOption(option, "key");
        const value = getOption(option);
        if (props.caseSensitiveSearch) return !selectedOptions.includes(key) && value.toString().includes(search);
        return !selectedOptions.includes(key) && value.toString().toLowerCase().includes(search.toLowerCase());
    };
    const options = props.options.filter(filter);
    const selectedIndex = currentIndex > options.length - 1 ? 0 : currentIndex;
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "ArrowUp":
                setCurrentIndex(selectedIndex < 1 ? 0 : currentIndex - 1);
                break;
            case "ArrowDown":
                setCurrentIndex(options.length - 1 === currentIndex ? currentIndex : selectedIndex + 1);
                break;
            case "Enter":
                currentIndex > -1 && selectOption(options[selectedIndex]);
                break;
            case "Backspace":
                if (selectedOptions.length > 0 && search === "") removeOption(selectedOptions[selectedOptions.length - 1]);
                break;
        }
    };
    const renderLoading = ()=>/*#__PURE__*/ (0, $4MPRY$jsxs)("div", {
            className: "react-multi-search-select-loading",
            children: [
                /*#__PURE__*/ (0, $4MPRY$jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 38 38",
                    stroke: "#fff",
                    children: /*#__PURE__*/ (0, $4MPRY$jsx)("g", {
                        fill: "none",
                        children: /*#__PURE__*/ (0, $4MPRY$jsxs)("g", {
                            transform: "translate(1 1)",
                            strokeWidth: "2",
                            children: [
                                /*#__PURE__*/ (0, $4MPRY$jsx)("circle", {
                                    cx: "18",
                                    cy: "18",
                                    r: "18",
                                    strokeOpacity: "0.5"
                                }),
                                /*#__PURE__*/ (0, $4MPRY$jsx)("path", {
                                    d: "M36 18c0-9.9-8.1-18-18-18",
                                    children: /*#__PURE__*/ (0, $4MPRY$jsx)("animateTransform", {
                                        attributeName: "transform",
                                        type: "rotate",
                                        from: "0 18 18",
                                        to: "360 18 18",
                                        dur: "1s",
                                        repeatCount: "indefinite"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4MPRY$jsx)("span", {
                    children: "Loading..."
                })
            ]
        });
    const getSelectedOptions = ()=>{
        return selectedOptions.filter((selectedOption)=>{
            if (props.optionsObject) return props.options.findIndex((option)=>option[props.optionsObject.key] === selectedOption) > -1;
            return props.options.includes(selectedOption);
        });
    };
    const renderSelectedOptions = ()=>{
        return getSelectedOptions().map((selectedOption, index)=>{
            const option = props.optionsObject ? props.options.find((option)=>option[props.optionsObject.key] === selectedOption)[props.optionsObject.value] : selectedOption;
            return /*#__PURE__*/ (0, $4MPRY$jsx)("button", {
                type: "button",
                className: "react-multi-search-select-selected-option",
                onClick: ()=>removeOption(selectedOption),
                children: option
            }, index);
        });
    };
    const renderOptions = ()=>/*#__PURE__*/ (0, $4MPRY$jsxs)("ul", {
            className: "react-multi-search-select-options-container" + (showOptions ? "" : " hide"),
            children: [
                options.length === 0 && /*#__PURE__*/ (0, $4MPRY$jsx)("li", {
                    className: "no-hover",
                    children: props.noOptionsText || "There are no options"
                }),
                options.map((option, index)=>/*#__PURE__*/ (0, $4MPRY$jsx)("li", {
                        className: selectedIndex === index ? "active" : "",
                        onClick: ()=>selectOption(option),
                        children: getOption(option)
                    }, "option-" + index))
            ]
        });
    const selectionLimitReached = selectedOptions.length >= props.selectionLimit;
    return /*#__PURE__*/ (0, $4MPRY$jsxs)("div", {
        className: "react-multi-search-select-container",
        children: [
            /*#__PURE__*/ (0, $4MPRY$jsxs)("div", {
                className: "react-multi-search-select-search-wrapper",
                children: [
                    props.loading && renderLoading(),
                    renderSelectedOptions(),
                    !props.loading && !selectionLimitReached && /*#__PURE__*/ (0, $4MPRY$jsx)("input", {
                        type: "text",
                        className: "searchBox",
                        value: search,
                        placeholder: props.placeholderText || "Select",
                        autoComplete: "off",
                        disabled: props.disabled,
                        onFocus: toggleOptions,
                        onBlur: ()=>void setTimeout(toggleOptions, 200),
                        onKeyDown: handleKeyDown,
                        onChange: handleSearch
                    })
                ]
            }),
            renderOptions()
        ]
    });
});


export {$090815f5086f7f29$export$5acdf7f97c483469 as ReactMultiSearchSelect};
//# sourceMappingURL=module.js.map
